import React from "react";
import AnimatedHeading from "../AnimatedHeading";
import { IMG } from "../../assetsBase";

function Hero() {
  return (
    <section className="orbia-hero_one" id="top">
      <div
        className="hero-wrapper bg_cover"
        style={{ backgroundImage: `url(${IMG}/hero/hero-bg.jpg)` }}
      >
        <div className="hero-shape shape-one">
          <img src={`${IMG}/hero/hero-shape2.png`} alt="shape" />
        </div>
        <div className="hero-shape shape-two">
          <img src={`${IMG}/hero/hero-shape1.png`} alt="shape" />
        </div>
        <div className="container-fluid">
          <div className="row justify-content-center justify-content-xl-start">
            <div className="col-xl-6 col-lg-10">
              <div className="hero-content text-center text-xl-start">
                <span
                  className="tag-line"
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  Digital &bull; Business &bull; Supply Solutions
                </span>
                <AnimatedHeading as="h1">
                  <span>Building Digital Innovation,</span> Business Growth
                  &amp; Global Supply <span>Solutions</span>
                </AnimatedHeading>
                <p data-aos="fade-up" data-aos-duration="1500">
                  Lozrian delivers innovative digital solutions, strategic
                  business services, and reliable supply &amp; trading solutions
                  that help organizations grow with confidence.
                </p>
                <div className="hero-button-wrap">
                  <div
                    className="orbia-button"
                    data-aos="fade-up"
                    data-aos-duration="1500"
                  >
                    <a href="#contact" className="theme-btn gradient-btn">
                      Contact Us<i className="far fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-10 position-relative">
              <div className="hero-image">
                <img src={`${IMG}/hero/hero-img16.png`} alt="Lozrian" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
